/**
 * LISTADO DE ENDPOINTS API GESTION CASOS (AUTENTICACION)
*/
const URL_API_AUTENTICACION = {
    IniciarSesion: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/IniciarSesion`,
    RenovarToken: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/RenovarToken`,
    GenerarOTP: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/GenerarOTP`,
    ValidarOTP: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/ValidarOTP`,
    VerificarUsuarioExiste: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/VerificarUsuarioExiste`,
    CambiarContrasena: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/CambiarContrasena`,
    ValidarContrasena: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/ValidarContrasena`,    
    RegistrarPerfil: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Contactos/RegistrarPerfil`,
}

/**
 * LISTADO DE ENDPOINTS API GESTION CASOS (AUTENTICACION) V2
*/
const URL_API_AUTENTICACION_V2 = {
    /**
     * Registrar un nuevo usuario (v2). Crea una nueva cuenta de usuario. 
     * La implementación debe validar los datos y enviar correo de verificación.
    */
    REGISTER: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/register`,
    /**
     * Inicio de sesión (v2): devuelve tokens de acceso y refresh. 
     * Valida credenciales y emite tokens. Soporta código 2FA opcional.
    */
    LOGIN: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/login`,
    /**
     * Renovación de tokens (v2): Intercambia un refresh token válido 
     * por un nuevo par de tokens.
    */
    REFRESH_TOKEN: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/refresh`,
    /**
     * Seleccionar entidad (v2): emite un nuevo par de tokens con los claims
     * `IdRelUsuarioEntidades`, `IdEntidad` e `IdRol` de la relación elegida.
     * Revoca el refresh token enviado. Responde 403 si la relación no es del usuario o no está activa.
     * @example
     * POST /api/Autenticacion/v2/seleccionar-entidad
    */
    SELECCIONAR_ENTIDAD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/seleccionar-entidad`,
    /**
     * Seleccionar persona física (v2): emite un nuevo par de tokens sin los claims
     * `IdRelUsuarioEntidades` ni `IdEntidad`. Revoca el refresh token enviado.
     * @example
     * POST /api/Autenticacion/v2/seleccionar-persona-fisica
    */
    SELECCIONAR_PERSONA_FISICA: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/seleccionar-persona-fisica`,
    /**
     * Cerrar sesión (v2) - revocar la sesión actual.
     * Revoca refresh tokens y finaliza la sesión autenticada.
    */
    LOGOUT: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/logout`,
    /**
     * Obtener información del usuario actual (v2).
     * 
    */
    ABOUT_ME: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/me`,
    /**
     * Cambiar contraseña para el usuario autenticado (v2).
    */
    CHANGE_PASSWORD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/change-password`,
    /**
     * Iniciar flujo de recuperación de contraseña (v2). 
     * Siempre devuelve 202 para evitar enumeración de cuentas.
    */
    FORGOT_PASSWORD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/forgot-password`,
    /**
     * Completar reseteo de contraseña (v2).
     * 
    */
    RESET_PASSWORD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/reset-password`,
    /**
     * Listar sesiones activas del usuario actual (v2).
    */
    SESSIONS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/sessions`,
    /**
     * Revocar una sesión por id (v2).
    */
    REVOKE_SESSION: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/sessions/{sessionId}`,
    /**
     * Revocar todas las sesiones del usuario actual (v2).
    */
    REVOKE_ALL: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/sessions/revoke-all`,
    /**
     * Verificar código 2FA (v2).
    */
    VERIFICAR_2FA_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/2fa/verify`,
    /**
     * Validar token de reseteo de contraseña (v2).
     * @example 
     * GET /api/Autenticacion/v2/validate-token-reset-password?token=abc123
     */
    VALIDATE_TOKEN_RESET_PASSWORD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/validate-token-reset-password`,
    /**
     * Obtener la hora del servidor (v2).
     * @example 
     * GET /api/Autenticacion/v2/time
     */
    TIME_V2: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Autenticacion/v2/time`
}

/**
 * LISTADO DE ENDPOINTS API CONSULTA GESTION CASOS
*/
const URL_API_CONSULTA_GESTION_CASOS = {
    /**
     * Buscar Crm ENDPOINT del API CONSULTA GESTION CASOS
    */
    BUSCAR_CRM: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Contactos/buscarCrm`,
    /**
     * GetAbogadosPorMatriculaCedula ENDPOINT del API CONSULTA GESTION CASOS
    */
    GET_ABOGADOS_POR_MATRICULA_CEDULA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Contactos/GetAbogadosPorMatriculaCedula`,
    /**
     * ValidarExisteAbogadoPorMatriculaCedula ENDPOINT del API CONSULTA GESTION CASOS
     * @example
     * GET /api/Contactos/v2/ValidarExisteAbogadoPorMatriculaCedula
    */
    VALIDAR_EXISTE_ABOGADO_POR_MATRICULA_CEDULA: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Contactos/v2/ValidarExisteAbogadoPorMatriculaCedula`
}

/**
 * LISTADO DE ENDPOINTS API `GestionCasosApi`
*/
const URL_API_GESTION_CASOS = {
    /**
     * ENDPOINT `VarificarEntidadExiste` del API `GestionCasosApi`
    */
    VERIFICAR_ENTIDAD_EXISTE: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Entidad/VarificarEntidadExiste`,
    /**
     * ENDPOINT `RegistrarPerfilEntidad` del API `GestionCasosApi`
    */
    REGISTRAR_PERFIL_ENTIDAD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/Entidad/RegistrarPerfilEntidad`,
}

const PALABRAS_IGNORADAS_RESET_PASSWORD = ["de", "la", "el", "y", "a", "en", "del", "los", "las", "un", "una", "unos", "unas", "con", "por", "para", "sin", "sobre", "al"
];

export {
    URL_API_AUTENTICACION,
    URL_API_AUTENTICACION_V2,
    URL_API_CONSULTA_GESTION_CASOS,
    URL_API_GESTION_CASOS,
    PALABRAS_IGNORADAS_RESET_PASSWORD
}